import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "text-primary" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = { class: "text-primary" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Convorally Corp.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "4804 Thacker Dairy Rd. Greensboro North Carolina 27406", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 336-215-4530")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" mail@convorally.com")
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "my-2" }
const _hoisted_11 = { class: "text-primary" }
const _hoisted_12 = { class: "text-primary" }
const _hoisted_13 = { class: "text-primary" }
const _hoisted_14 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_15 = { class: "text-primary" }
const _hoisted_16 = { class: "block-items" }
const _hoisted_17 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_18 = { class: "text-primary" }
const _hoisted_19 = { class: "text-primary" }
const _hoisted_20 = { class: "text-primary" }
const _hoisted_21 = { class: "to-upper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, [
        _createVNode("strong", null, _toDisplayString(_ctx.$t('privacy_statement')), 1)
      ]),
      _createVNode("p", null, _toDisplayString(_ctx.$t('privacy_statement_line_1')) + _toDisplayString(_ctx.$t('privacy_statement_line_2')) + " " + _toDisplayString(_ctx.$t('privacy_statement_line_3')) + _toDisplayString(_ctx.$t('privacy_statement_line_4')) + " " + _toDisplayString(_ctx.$t('privacy_statement_line_5')), 1),
      _hoisted_3,
      _createVNode("p", _hoisted_4, [
        _createVNode("strong", null, _toDisplayString(_ctx.$t('company_detail')), 1)
      ]),
      _hoisted_5,
      _hoisted_6,
      _createVNode("p", null, [
        _createVNode("strong", null, _toDisplayString(_ctx.$t('telephone')) + ":", 1),
        _hoisted_7
      ]),
      _createVNode("p", null, [
        _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + ":", 1),
        _hoisted_8
      ]),
      _createVNode("p", null, _toDisplayString(_ctx.$t('we_reference_explanation')), 1),
      _createVNode("p", _hoisted_9, [
        _createVNode("i", null, "* " + _toDisplayString(_ctx.$t('privacy_read_statement')) + " *", 1)
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("p", _hoisted_11, [
          _createVNode("strong", null, _toDisplayString(_ctx.$t('who_are_we')), 1)
        ]),
        _createVNode("p", null, _toDisplayString(_ctx.$t('company_intro')) + " " + _toDisplayString(_ctx.$t('services_offered')) + " " + _toDisplayString(_ctx.$t('data_processing_purpose')) + " " + _toDisplayString(_ctx.$t('contact_form_request')) + " " + _toDisplayString(_ctx.$t('data_usage')) + " " + _toDisplayString(_ctx.$t('data_encryption')) + " " + _toDisplayString(_ctx.$t('data_backup_policy')), 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('quote_request_storage')) + " " + _toDisplayString(_ctx.$t('quote_retention_policy')) + " " + _toDisplayString(_ctx.$t('site_hosting_security')) + " " + _toDisplayString(_ctx.$t('email_tls_security')), 1)
      ]),
      _createVNode("p", _hoisted_12, [
        _createVNode("strong", null, _toDisplayString(_ctx.$t('data_processing_reason')) + _toDisplayString(_ctx.$t('legal_basis')) + ".", 1)
      ]),
      _createVNode("p", null, _toDisplayString(_ctx.$t('data_collection_reason')), 1),
      _createVNode("p", _hoisted_13, [
        _createVNode("strong", null, _toDisplayString(_ctx.$t('data_usage_question')), 1)
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('data_processing_statement')) + " " + _toDisplayString(_ctx.$t('data_accuracy_effort')) + " ", 1),
      _hoisted_14,
      _createVNode("p", _hoisted_15, [
        _createVNode("strong", null, _toDisplayString(_ctx.$t('data_rights_statement')), 1)
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("ul", null, [
          _createVNode("li", null, _toDisplayString(_ctx.$t('right_of_access')) + " " + _toDisplayString(_ctx.$t('right_of_rectification')), 1),
          _createVNode("li", null, _toDisplayString(_ctx.$t('right_to_be_forgotten')), 1),
          _createVNode("li", null, _toDisplayString(_ctx.$t('right_to_restriction_of_processing')), 1),
          _createVNode("li", null, _toDisplayString(_ctx.$t('right_of_portability')), 1),
          _createVNode("li", null, _toDisplayString(_ctx.$t('right_to_object')) + ". ", 1)
        ])
      ]),
      _hoisted_17,
      _createVNode("p", _hoisted_18, [
        _createVNode("strong", null, _toDisplayString(_ctx.$t('retention_of_personal_data')), 1)
      ]),
      _createVNode("p", null, _toDisplayString(_ctx.$t('data_retention_statement')), 1),
      _createVNode("p", _hoisted_19, [
        _createVNode("strong", null, _toDisplayString(_ctx.$t('complaints')), 1)
      ]),
      _createVNode("p", null, _toDisplayString(_ctx.$t('complaint_instruction')), 1),
      _createVNode("p", _hoisted_20, [
        _createVNode("strong", _hoisted_21, _toDisplayString(_ctx.$t('contact_us')), 1)
      ]),
      _createVNode("p", null, _toDisplayString(_ctx.$t('privacy_importance')), 1)
    ])
  ]))
}